module.exports = __webpack_public_path__ + "img/A05F31_D5C2BC_D9996F_42230E-256px.4f515d1a.png";